import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Funnel',
    description: 'Funnel is a paid advertising agency scaling brands with Meta, Google and TikTok ads that deliver measurable growth, increased sales and higher profitability.',
    placeholder: 'Your new site will appear right here. Just ask Modulify to generate anything you can describe.',
    url: getOrigin()
}

export const navLinks = [
    { label: 'About', href: '/about' },
    { label: 'Blog', href: '/blog' },
    { label: 'Services', href: '/services' },
    { label: 'Process', href: '/#process' },
    { label: 'Contact', href: '/contact' }
]

export const pagesMenu = [
    { label: 'Results', href: '/#results' },
    { label: 'Comparison', href: '/#comparison' },
    { label: 'FAQ', href: '/#faq' },
    { label: 'Legal', href: '/legal' },
    { label: 'Coming Soon', href: '/coming-soon' },
    { label: '404', href: '/404' }
]

export const footerSitemap = [
    {
        heading: 'Pages',
        links: [
            { label: 'About', href: '/about' },
            { label: 'Blog', href: '/blog' },
            { label: 'Services', href: '/services' },
            { label: '404', href: '/404' }
        ]
    },
    {
        heading: 'Information',
        links: [
            { label: 'FAQ', href: '/#faq' },
            { label: 'Contact', href: '/contact' },
            { label: 'Legal', href: '/legal' },
            { label: 'Coming Soon', href: '/coming-soon' }
        ]
    }
]
